<template>
  <div>
    <div class="page-nav">
      <img src="@/assets/home-icon.png" @click="gotoHome" />
      <div @click="gotoHome">首页 ></div>
      <div class="text">企业概况</div>
    </div>

    <div class="intro-title">公司简介</div>

    <div class="intro-box">
      <div class="intro-left">
        <div class="left-text">
          <div v-html="$utils.escape2Html(intro.content)"></div>
        </div>
        <div class="left-stat">
          <div class="stat-item">
            <div class="stat-num">
              <div class="num-text">{{ intro.device }}</div>
            </div>
            <div class="stat-text">设备</div>
          </div>
          <div class="stat-item">
            <div class="stat-num">
              <div class="num-text">{{ intro.car }}</div>
            </div>
            <div class="stat-text">车辆</div>
          </div>
          <div class="stat-item">
            <div class="stat-num">
              <div class="num-text">{{ intro.member }}</div>
            </div>
            <div class="stat-text">人员</div>
          </div>
        </div>
      </div>
      <div class="intro-right">
        <swiper class="intro-swiper" :options="introSwiperOption">
          <swiper-slide v-for="(item, index) in intro.imgs" :key="index">
            <img :src="$utils.getFileHttpUrl(item)" />
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <!-- <div class="tech-box">
      <div class="tech-title">
        <div>技术展示</div>
        <div class="title-more" @click="gotoMore('enterpriseTech')">
          <div>MORE</div>
          <img src="@/assets/arrow-right.png" />
        </div>
      </div>
      <div class="tech-swiper">
        <swiper ref="techSwiper" class="t-swiper" :options="techSwiperOption">
          <swiper-slide v-for="(item, index) in techInfo" :key="index">
            <img :src="$utils.getFileHttpUrl(item.img)"/>
            <div class="tech-project">
              <div class="project-name">{{ item.subTitle }}</div>
              <div class="project-line"></div>
            </div>
          </swiper-slide>
        </swiper>
        <img src="@/assets/swiper-circle-next.png" class="swiper-button-tech swiper-button-tech-next" slot="button-next" />
        <img src="@/assets/swiper-circle-prev.png" class="swiper-button-tech swiper-button-tech-prev" slot="button-prev" />
      </div>
    </div> -->

    <div class="device-box">
      <div class="device-title">设备展示</div>
      <div class="device-content">
        <div class="device-left">
          <div class="device-text">
            <div v-html="$utils.escape2Html(deviceText)"></div>
          </div>
          <div class="device-swiper">
            <swiper ref="deviceSwiper" class="d-swiper" :options="deviceSwiperOption">
              <swiper-slide v-for="(item, index) in deviceInfo" :key="index">
                <img :src="$utils.getFileHttpUrl(item.img)" />
              </swiper-slide>
            </swiper>
            <img src="@/assets/swiper-next2.png" class="swiper-button-next" slot="button-next" />
            <img src="@/assets/swiper-prev2.png" class="swiper-button-prev" slot="button-prev" />
          </div>
        </div>
        <div class="device-right">
          <img :src="$utils.getFileHttpUrl(deviceImg)" />
        </div>
      </div>
    </div>

    <div class="team-box">
      <div class="team-title">团队风采</div>
      <div class="team-imgs">
        <div class="img-item" v-for="(item, index) in teamInfo" :key="index">
          <img :src="$utils.getFileHttpUrl(item.img)" />
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageSwiper from '@/components/PageSwiper'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: { PageSwiper, Swiper, SwiperSlide },
  data() {
    return {
      intro: {},
      introSwiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      },
      techSwiperOption: {
        // preloadImages: false,
        // freeMode: true,
        // speed: 3000,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        slidesPerView: 3,
        spaceBetween: 40,
        navigation: {
          prevEl: '.swiper-button-tech-prev',
          nextEl: '.swiper-button-tech-next'
        },
        on: {
          click: () => {
            const swiper = this.$refs.techSwiper.$swiper
            const totalRealSlides = this.techInfo.length
            let realIndex = swiper.clickedIndex - swiper.loopedSlides
            if (realIndex < 0) {
              realIndex += totalRealSlides
            } else if (realIndex >= totalRealSlides) {
              realIndex -= totalRealSlides
            }
            console.log('点击的真实索引:', realIndex)
            this.$router.push({ name: 'enterpriseTech', query: {realIndex: realIndex} })
          }
        }
      },
      techInfo: [],
      deviceSwiperOption: {
        // preloadImages: false,
        // freeMode: true,
        // speed: 2000,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        slidesPerView: 3,
        centeredSlides: true,
        allowTouchMove: false,
        spaceBetween: 30,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        },
        on: {
          // init: () => {
          //   this.$nextTick(() => {
          //     console.log('init', this.$refs.deviceSwiper.$swiper)
          //     // this.$refs.deviceSwiper.$swiper.slideToLoop(4)
          //   })
          // },
          slideChangeTransitionEnd: () => {
            let realIndex = this.$refs.deviceSwiper.$swiper.realIndex
            this.deviceText = this.deviceInfo[realIndex].content
            this.deviceImg = this.deviceInfo[realIndex].img
          }
          // click: () => {
          //   let clickedIndex =  this.$refs.deviceSwiper.$swiper.clickedIndex % 3
          //   console.log('click', clickedIndex)
          //   if(clickedIndex >= 0) {
          //     this.deviceText = this.deviceInfo[clickedIndex].content
          //     this.deviceImg = this.deviceInfo[clickedIndex].img
          //   }
          // }
        }
      },
      deviceInfo: [],
      deviceText: '',
      deviceImg: '',
      teamInfo: []
    }
  },
  created() {
    this.getIntro()
    this.getTechInfo()
    this.getDeviceInfo()
    this.getTeamInfo()
  },
  methods: {
    gotoHome() {
      this.$router.replace({ name: 'home' })
    },
    getIntro() {
      this.$http.getAction('/portal/api/v1/intro').then((res) => {
        if (res.success) {
          this.intro = res.data
        }
      })
    },
    getTechInfo() {
      this.$http.getAction('/portal/api/v1/intro/technology').then((res) => {
        if (res.success) {
          this.techInfo = res.data
        }
      })
    },
    gotoMore(name) {
      this.$router.push({ name: name })
    },
    getDeviceInfo() {
      this.$http.getAction('/portal/api/v1/intro/devices').then((res) => {
        if (res.success) {
          this.deviceInfo = res.data
          if (res.data?.length > 0) {
            this.deviceText = res.data[1].content
            this.deviceImg = res.data[1].img
          }
        }
      })
    },
    deviceSliderMove(swiper, event) {
      console.log(swiper, event)
    },
    getTeamInfo() {
      this.$http.getAction('/portal/api/v1/intro/team/style').then((res) => {
        if (res.success) {
          this.teamInfo = res.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-nav {
  display: flex;
  align-items: center;
  width: 1200px;
  margin: 30px auto 70px;
  font-weight: 500;
  font-size: 14px;
  color: #898989;
  line-height: 16px;
  cursor: pointer;
  img {
    width: 20px;
    height: 20px;
    margin-right: 15px;
  }
  .text {
    padding-left: 6px;
    color: #333333;
  }
}

.intro-title {
  width: 1200px;
  margin: 0 auto;
  height: 40px;
  font-weight: 800;
  font-size: 30px;
  color: #0282de;
  line-height: 40px;
}
.intro-box {
  padding-top: 24px;
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  .intro-left {
    width: 600px;
    .left-text {
      height: 280px;
      overflow: hidden;
    }
    .left-stat {
      padding-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .stat-item {
        width: 33%;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-right: 1px solid #cfcfcf;
        &:nth-of-type(3) {
          border-right: none;
        }
        .stat-num {
          position: relative;

          .num-text {
            height: 50px;
            font-weight: bold;
            font-size: 40px;
            color: #0282de;
          }
          &::after {
            position: absolute;
            display: inline-block;
            content: '+';
            color: #0282de;
            font-size: 30px;
            top: -20px;
            right: -25px;
          }
        }
        .stat-text {
          padding-top: 2px;
          height: 28px;
          font-weight: 500;
          font-size: 18px;
          color: #3f3f3f;
          line-height: 28px;
        }
      }
    }
  }
  .intro-right {
    width: 550px;
    .intro-swiper {
      width: 100%;
      .swiper-slide {
        img {
          width: 100%;
          height: 390px;
          object-fit: cover;
        }
      }
    }
  }
}
.intro-bg {
  width: 100%;
  height: 500px;
  margin-top: 100px;
  background-image: url(../assets/enterpreise-bg.jpg);
  background-size: cover;
}
.tech-box {
  width: 1200px;
  margin: 100px auto 0;
  .tech-title {
    font-weight: 800;
    font-size: 40px;
    color: #0282de;
    line-height: 47px;
    text-align: center;
    position: relative;
    .title-more {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 16px;
      color: #777777;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
  .tech-swiper {
    margin-top: 100px;
    position: relative;
    .t-swiper {
      width: 100%;
      .swiper-slide {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        img {
          width: 350px;
          height: 400px;
          object-fit: cover;
        }
        .tech-project {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          padding-top: 20px;
          height: 55px;
          width: 100%;

          .project-name {
            font-weight: 800;
            font-size: 20px;
            color: #000000;
            width: 60%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 20px;
            width: 100%;
            text-align: center;
          }

          .project-line {
            width: 70px;
            height: 10px;
            background: #0282de;
          }
        }
      }
    }
    .swiper-button-tech {
      position: absolute;
      top: 50%;
      cursor: pointer;
    }
    .swiper-button-tech-next {
      right: -60px;
      width: 40px;
      height: 40px;
    }
    .swiper-button-tech-prev {
      left: -60px;
      right: auto;
      width: 40px;
      height: 40px;
    }
  }
}
.device-box {
  width: 1200px;
  padding-top: 100px;
  margin: 0 auto;
  .device-title {
    font-weight: 800;
    font-size: 40px;
    color: #0282de;
  }
  .device-content {
    display: flex;
    justify-content: space-between;
    .device-left {
      width: 540px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .device-text {
        height: 260px;
        overflow: hidden;
      }
      .device-swiper {
        width: calc(100% - 60px);
        margin: 0 auto;
        position: relative;
        .d-swiper {
          .swiper-slide {
            img {
              width: 100%;
              height: 120px;
              object-fit: cover;
              cursor: pointer;
            }
          }
        }
        .swiper-button-next {
          right: -30px;
          width: 20px;
          height: 20px;
          top: 72px;
        }
        .swiper-button-prev {
          left: -30px;
          right: auto;
          width: 20px;
          height: 20px;
          top: 72px;
        }
      }
    }
    .device-right {
      width: 600px;
      height: 450px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.team-box {
  width: 1200px;
  margin: 0 auto;
  padding-top: 100px;
  .team-title {
    font-weight: 800;
    font-size: 40px;
    color: #0282de;
    text-align: center;
  }
  .team-imgs {
    margin-top: 50px;
    display: flex;
    flex-wrap: wrap;
    .img-item {
      width: 280px;
      height: 280px;
      margin-right: 26px;
      margin-top: 30px;
      position: relative;
      &:nth-of-type(4n) {
        margin-right: 0;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .name {
        position: absolute;
        left: 17px;
        bottom: 0;
        width: 240px;
        height: 40px;
        font-weight: bold;
        font-size: 14px;
        color: #ffffff;
        line-height: 40px;
      }
    }
  }
}
</style>
